// // File: src/hooks/useAddProject.js
// File: src/hooks/Refund/useAddProject_Credit.js

import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Api_Url } from "../../utils/ApiUrl";
import { REFUND_PROJECT_DATA } from "../../utils/Constants";

export function useAddProject({ getData, data, isEditMode = false, editData = null, onEditComplete = () => { } }) {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formData, setFormData] = useState({
        selectedProject: null,
        purchaseLimit: "",
        purchaseLimitPerUser: "",
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isAddingProject, setIsAddingProject] = useState(false);

    // Create a Set of existing privateSales
    const existingPrivateSales = data
        ? new Set(data.map((item) => item.privateSale))
        : new Set([editData?.privateSale]);

    // Filter projects
    const filteredProjects = isEditMode
        ? REFUND_PROJECT_DATA.filter((project) => project.value === editData?.privateSale)
        : REFUND_PROJECT_DATA.filter((project) => !existingPrivateSales.has(project.value));

    useEffect(() => {
        if (isEditMode && editData) {
            const selectedProjectObj = REFUND_PROJECT_DATA.find(
                (project) => project.value === editData.privateSale
            );
            setFormData({
                selectedProject: selectedProjectObj || null,
                purchaseLimit: editData.purchaseLimit.toString(),
                purchaseLimitPerUser: editData.purchaseLimitPerUser.toString(),
            });
            setShowAddModal(true);
        }
    }, [isEditMode, editData]);

    const handleOpenAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => {
        setShowAddModal(false);
        if (isEditMode) onEditComplete();
    };

    const handleOpenSuccessModal = () => setShowSuccessModal(true);
    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        if (isEditMode) onEditComplete();
    };

    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    const handleProjectSelect = (project) => {
        setFormData({ ...formData, selectedProject: project });
        setIsDropdownOpen(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (
            name.startsWith("purchaseLimit") &&
            (!isNaN(value) && (value === "" || parseInt(value) >= 0))
        ) {
            setFormData({ ...formData, [name]: value });
        } else if (name === "selectedProject") {
            setFormData({ ...formData, [name]: value });
        }
    };

    const submitProject = async (payload) => {
        try {
            const endpoint = isEditMode
                ? `${Api_Url}/credit/purchasable/projects/edit`
                : `${Api_Url}/credit/purchasable/projects`;

            if (isEditMode && editData) {
                payload.id = editData._id;
                delete payload.privateSale;
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
            };

            let response;
            if (isEditMode) {
                response = await axios.patch(endpoint, payload, config);
            } else {
                response = await axios.post(endpoint, payload, config);
            }

            if (response.status === 200 || response.status === 201) {
                setIsAddingProject(false);
                handleCloseAddModal();
                handleOpenSuccessModal();
                setFormData({
                    selectedProject: null,
                    purchaseLimit: "",
                    purchaseLimitPerUser: "",
                });
                getData();
                return true;
            } else {
                setIsAddingProject(false);
                toast.error(
                    `Failed to ${isEditMode ? "update" : "add"} project: ${response.data?.message || "Something went wrong"}`
                );
                console.error(`Failed to ${isEditMode ? "update" : "add"} project:`, response);
                return false;
            }
        } catch (error) {
            setIsAddingProject(false);
            toast.error(`Error ${isEditMode ? "updating" : "adding"} project: ${error.message}`);
            console.error(`Error ${isEditMode ? "updating" : "adding"} project:`, error);
            return false;
        }
    };

    const handleAddProject = async () => {
        const { selectedProject, purchaseLimit, purchaseLimitPerUser } = formData;

        if (!selectedProject) {
            toast.warn("Please select a project.");
            return;
        }
        if (purchaseLimit === "") {
            toast.warn("Please enter the purchase limit.");
            return;
        }
        if (purchaseLimitPerUser === "") {
            toast.warn("Please enter the purchase limit per user.");
            return;
        }

        const parsedPurchaseLimit = parseInt(purchaseLimit);
        const parsedPurchaseLimitPerUser = parseInt(purchaseLimitPerUser);

        if (parsedPurchaseLimit <= 0 || parsedPurchaseLimitPerUser <= 0) {
            toast.error("Purchase limits must be at least 1.");
            return;
        }

        if (parsedPurchaseLimit <= parsedPurchaseLimitPerUser) {
            toast.error("Purchase limit must be greater than the purchase limit per user.");
            return;
        }

        setIsAddingProject(true);
        const payload = {
            privateSale: selectedProject.value,
            purchaseLimit: parsedPurchaseLimit,
            purchaseLimitPerUser: parsedPurchaseLimitPerUser,
            isActive: true,
        };
        await submitProject(payload);
    };

    return {
        showAddModal,
        showSuccessModal,
        formData,
        isDropdownOpen,
        isAddingProject,
        filteredProjects,
        handleOpenAddModal,
        handleCloseAddModal,
        handleOpenSuccessModal,
        handleCloseSuccessModal,
        toggleDropdown,
        handleProjectSelect,
        handleInputChange,
        handleAddProject,
    };
}
// import { useState } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { Api_Url } from "../../utils/ApiUrl";
// import { REFUND_PROJECT_DATA } from "../../utils/Constants";

// export function useAddProject({ getData, data }) {
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false);
//     const [formData, setFormData] = useState({
//         selectedProject: null,
//         purchaseLimit: "",
//         purchaseLimitPerUser: "",
//     });
//     const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//     const [isAddingProject, setIsAddingProject] = useState(false);

//     const handleOpenAddModal = () => setShowAddModal(true);
//     const handleCloseAddModal = () => setShowAddModal(false);
//     const handleOpenSuccessModal = () => setShowSuccessModal(true);
//     const handleCloseSuccessModal = () => setShowSuccessModal(false);
//     const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

//     // Create a Set of all privateSale values from the first array for efficient lookup
//     const existingPrivateSales = new Set(data.map((item) => item.privateSale));

//     // Filter REFUND_PROJECT_DATA to only include items whose value doesn't exist in the Set
//     const filteredProjects = REFUND_PROJECT_DATA.filter(
//         (project) => !existingPrivateSales.has(project.value)
//     );

//     const handleProjectSelect = (project) => {
//         setFormData({ ...formData, selectedProject: project });
//         setIsDropdownOpen(false);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (
//             name.startsWith("purchaseLimit") &&
//             (!isNaN(value) && (value === "" || parseInt(value) >= 0))
//         ) {
//             setFormData({ ...formData, [name]: value });
//         } else if (name === "selectedProject") {
//             setFormData({ ...formData, [name]: value });
//         }
//     };

//     const addProjectToApi = async (payload) => {
//         try {
//             const response = await axios.post(
//                 Api_Url + "/credit/purchasable/projects",
//                 payload,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//                     },
//                 }
//             );
//             if (response.status === 200 || response.status === 201) {
//                 setIsAddingProject(false);
//                 handleCloseAddModal();
//                 handleOpenSuccessModal();
//                 setFormData({
//                     selectedProject: null,
//                     purchaseLimit: "",
//                     purchaseLimitPerUser: "",
//                 });
//                 getData();
//                 return true;
//             } else {
//                 setIsAddingProject(false);
//                 toast.error(
//                     `Failed to add project: ${response.data?.message || "Something went wrong"}`
//                 );
//                 console.error("Failed to add project:", response);
//                 return false;
//             }
//         } catch (error) {
//             setIsAddingProject(false);
//             toast.error(`Error adding project: ${error.message}`);
//             console.error("Error adding project:", error);
//             return false;
//         }
//     };

//     const handleAddProject = async () => {
//         const { selectedProject, purchaseLimit, purchaseLimitPerUser } = formData;

//         if (!selectedProject) {
//             toast.warn("Please select a project.");
//             return;
//         }
//         if (purchaseLimit === "") {
//             toast.warn("Please enter the purchase limit.");
//             return;
//         }
//         if (purchaseLimitPerUser === "") {
//             toast.warn("Please enter the purchase limit per user.");
//             return;
//         }

//         const parsedPurchaseLimit = parseInt(purchaseLimit);
//         const parsedPurchaseLimitPerUser = parseInt(purchaseLimitPerUser);

//         if (parsedPurchaseLimit <= 0 || parsedPurchaseLimitPerUser <= 0) {
//             toast.error("Purchase limits must be at least 1.");
//             return;
//         }

//         if (parsedPurchaseLimit <= parsedPurchaseLimitPerUser) {
//             toast.error("Purchase limit must be greater than the purchase limit per user.");
//             return;
//         }

//         setIsAddingProject(true);
//         const payload = {
//             privateSale: selectedProject.value,
//             purchaseLimit: parsedPurchaseLimit,
//             purchaseLimitPerUser: parsedPurchaseLimitPerUser,
//             isActive: true,
//         };
//         await addProjectToApi(payload);
//     };

//     return {
//         showAddModal,
//         showSuccessModal,
//         formData,
//         isDropdownOpen,
//         isAddingProject,
//         filteredProjects,
//         handleOpenAddModal,
//         handleCloseAddModal,
//         handleOpenSuccessModal,
//         handleCloseSuccessModal,
//         toggleDropdown,
//         handleProjectSelect,
//         handleInputChange,
//         handleAddProject,
//     };
// }
